import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { SMART_APP_LINK } from '@constants/appLinks';

import './index.scss';

interface QRCodeComponentProps {
  code?: string;
  size?: number;
  className?: string;
  includeMargin?: boolean;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({
  code = SMART_APP_LINK,
  size = 172,
  className = '',
  includeMargin = true
}) => (
  <div className={`qr-code-component ${className}`}>
    <div className='qr-code-wrapper'>
      <QRCodeSVG
        value={code}
        size={size}
        level='M'
        marginSize={includeMargin ? 10 : 0}
      />
    </div>
  </div>
);

export default QRCodeComponent;
